module.exports = __webpack_public_path__ + "img/ld.5992550d.png";